import { FunctionComponent } from "react";
import { Table } from "rsuite";
import { ApiSchemaCardDetails, TypeCardBrand } from "../../models/api";
import {
  SvgAmericanExpress,
  SvgCartesBancaires,
  SvgDinersClub,
  SvgDiscover,
  SvgJcb,
  SvgMastercard,
  SvgUnionPay,
  SvgVisa,
} from "../../assets/svg";

const { Column, HeaderCell, Cell } = Table;
interface IProps {
  isLoading: boolean;
  data: ApiSchemaCardDetails[];
}

const brandMap: { [key in TypeCardBrand]: FunctionComponent } = {
  visa: SvgVisa,
  amex: SvgAmericanExpress,
  cartes_bancaires: SvgCartesBancaires,
  diners: SvgDinersClub,
  discover: SvgDiscover,
  jcb: SvgJcb,
  mastercard: SvgMastercard,
  unionpay: SvgUnionPay,
};

export function PaymentMethods({ isLoading, data }: IProps) {
  return (
    <Table data={data} loading={isLoading} rowHeight={50}>
      <Column flexGrow={1}>
        <HeaderCell className="fw-bold text-black">Name</HeaderCell>
        <Cell>
          {(rowData: ApiSchemaCardDetails) => {
            const Brand = brandMap[rowData.paymentCardBrand];
            return (
              <div className="card-holder">
                <Brand />
                <div className="card-last-digit">
                  &#8727;&#8727;&#8727;&#8727; &#8727;&#8727;&#8727;&#8727;
                  &#8727;&#8727;&#8727;&#8727; {rowData.paymentCardSuffix}
                </div>
              </div>
            );
          }}
        </Cell>
      </Column>
      <Column flexGrow={1}>
        <HeaderCell className="fw-bold text-black">Expiration Date</HeaderCell>
        <Cell dataKey="paymentCardExpiryDate" />
      </Column>
      <Column flexGrow={1}>
        <HeaderCell className="fw-bold text-black">Status</HeaderCell>
        <Cell>
          {(rowData: ApiSchemaCardDetails) => {
            return rowData.paymentCardActive ? (
              <span className="badge bg-success">active</span>
            ) : (
              <span className="badge bg-danger">inactive</span>
            );
          }}
        </Cell>
      </Column>
      <Column flexGrow={1}>
        <HeaderCell className="fw-bold text-black">Type</HeaderCell>
        <Cell>
          {(rowData: ApiSchemaCardDetails) => {
            const className =
              rowData.paymentCardType === "credit" ? "bg-info" : "bg-primary";
            return (
              <span className={`badge ${className}`}>
                {rowData.paymentCardType}
              </span>
            );
          }}
        </Cell>
      </Column>
    </Table>
  );
}
